import { DeviceModel } from 'src/app/model/device-model';
import { Product } from '../model/software-update.models';
import { SoftwareUpdateProductOption } from '../model/software-update-product-option';

export const AUTOMATION_CATEGORY_ID = 7;

/** Chiave numerica univoca scheda: BoardClass + BoardId (univoci nel catalogo modelli). */
export function encodeBoardOptionId(boardClass: number, boardId: number): number {
	return boardClass * 1000 + boardId;
}

/** Decodifica l'ID della scheda in classe e ID. */
export function decodeBoardOptionId(optionId: number): { boardClass: number; boardId: number } {
	return {
		boardClass: Math.floor(optionId / 1000),
		boardId: optionId % 1000,
	};
}

/** Ottiene il nome della scheda. */
export function getBoardDisplayName(model: DeviceModel): string {
	const name = model.ProductBoardName?.trim() || model.BoardName?.trim() || '';
	return name.toUpperCase();
}

/** Ottiene le opzioni di modello di dispositivo. */
export function parseDeviceModelOptions(models: DeviceModel[]): SoftwareUpdateProductOption[] {
	return models
		.filter((model) => model.Id != null && model.ProductName?.trim())
		.map((model) => ({
			id: model.Id,
			name: model.ProductName.trim(),
		}))
		.sort((a, b) => a.name.localeCompare(b.name, undefined, { sensitivity: 'base' }));
}

/** Ottiene le opzioni della scheda. */
export function parseBoardOptions(models: DeviceModel[]): SoftwareUpdateProductOption[] {
	const seen = new Set<number>();
	const options: SoftwareUpdateProductOption[] = [];

	for (const model of models) {
		if (model.CategoryId !== AUTOMATION_CATEGORY_ID || model.BoardClass == null || model.BoardId == null) {
			continue;
		}
		const id = encodeBoardOptionId(model.BoardClass, model.BoardId);
		if (seen.has(id)) {
			continue;
		}
		const name = getBoardDisplayName(model);
		if (!name) {
			continue;
		}
		seen.add(id);
		options.push({ id, name });
	}

	return options.sort((a, b) => a.name.localeCompare(b.name, undefined, { sensitivity: 'base' }));
}

/** Ottiene l'ID della scheda. */
export function resolveBoardOptionId(
	product: Product | undefined,
	options: SoftwareUpdateProductOption[],
): number | null {
	if (!product || product.type !== 'board') {
		return null;
	}
	const crpClassName = product.crpClassName?.trim();
	if (crpClassName) {
		const parsed = Number(crpClassName);
		if (!Number.isNaN(parsed) && parsed > 0) {
			return parsed;
		}
	}
	if (product.modelId != null && product.modelId > 0) {
		return product.modelId;
	}
	const boardName = product.boardName?.trim();
	if (!boardName) {
		return null;
	}
	const normalized = boardName.toUpperCase();
	const match = options.find((option) => option.name.toUpperCase() === normalized);
	return match?.id ?? null;
}
